import { ServicesUseCase } from '../../../data/usecases'
import { makeAxiosHttpClient } from '../../factories'

type fetchSelectsForConstructorModel = {
  idConstructo: number | string
  idService: number | string
}

export const fetchConstructor = () => {
  return new ServicesUseCase(
    `/aplicacaoTeste/loadConstrutos`,
    makeAxiosHttpClient()
  )
}

export const fetchSelectsForConstructor = ({
  idConstructo,
  idService
}: fetchSelectsForConstructorModel) => {
  return new ServicesUseCase(
    `/aplicacaoTeste/loadTestes/${idConstructo}/${idService}`,
    makeAxiosHttpClient()
  )
}
export const fetchGenericSelectsForConstructor = () => {
  return new ServicesUseCase(
    `/aplicacaoTeste/loadClassificacaoGenerica`,
    makeAxiosHttpClient()
  )
}
